import { Box, BoxProps } from '@chakra-ui/react';
import { PropsWithChildren } from 'react';

export const ActiveItemWrapper = ({
  isActive,
  isPreview,
  children,
  ...props
}: PropsWithChildren<{ isActive: boolean; isPreview: boolean | undefined } & BoxProps>) =>
  isPreview ? (
    <Box
      border="6px solid"
      borderColor={isActive ? 'arcticBlue' : 'transparent'}
      transition="border 120ms ease-in-out"
      {...props}
    >
      {children}
    </Box>
  ) : (
    <>{children}</>
  );
